import { Component, Input, OnChanges, SimpleChanges, HostListener} from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from '../../app.state';
import { closeTodosPanel } from '../../visual/visual.actions';

@Component({
  selector: 'nns-todos-panel',
  styles: [`
    :host {
      position:fixed;
      right:0;
      top:0;
      padding:57px 0 0 0;
      box-sizing:border-box;
      width:100%;
      height:100%;
      z-index:69;
    }
    .shade {
      background: rgba(60,72,73,0.30);
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
    }
    .wrapper {
      position:relative;
      width:100%;
      height:100%;
    }
    .content {
      position:absolute;
      right:0;
      top:0;
      width:420px;
      height:100%;
      box-sizing:border-box;
      background:#fff;
      box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
      z-index:5;
    }

    .top {
      padding:8px;
      border-bottom:1px solid #cdcdcd;
    }

    .title {
      display:block;
      color:rgba(0,0,0, 0.8);
      font-size:18px;
      line-height:1;
      padding:8px;
    }
    .title .title-count {
      margin:0 8px 0 0;
    }
    .title .title-count-shape {
      background:#1F95A7;
      border-radius:2px;
      min-width:24px;
      height:24px;
      padding:0 4px;
      text-align:center;
      color:#fff;
      font-weight:bold;
      font-size:16px;
    }
    .close-button {
      padding:8px;
    }

    .inner {
      overflow:auto;
    }

    :host-context(.nns-fullscreen) {
      padding:0;
      z-index:450;
    }

    .active {display:block;}

    :host.nns-full-screen{
      padding-top: 0;
    }
  `, `
    :host-context(.nns-theme-night) .shade {
      background:rgba(0,0,0,0.60);
    }
    :host-context(.nns-theme-night) .content {
      background: #292E32;
      box-shadow:0 2px 4px 0 rgba(0,0,0,0.50);
    }
    :host-context(.nns-theme-night) .title {
      color:#fff;
    }
    :host-context(.nns-theme-night) .top {
      border-color:rgba(0,0,0,0.12);
    }
  `],
  template: `
    <div class="wrapper">
      <div class="shade" (click)="closeTodosPanel()"></div>
      <div class="content" flex layout="column">
        <div class="top" flex="none" layout="row" layout-align="space-between center">

          <div class="title" flex="none">
            <span class="title-layout" flex layout="row" layout-align="start center">
              <span class="title-count" flex="none">
                <span class="title-count-shape"
                  flex="none" layout="row" layout-align="center center"
                >{{todosUnchecked.length}}</span>
              </span>
              <span class="title-text">To-do</span>
            </span>
          </div>

          <div class="close-button" flex="none">
            <nns-button class="transparent" icon="close-s" (click)="closeTodosPanel()"></nns-button>
          </div>

        </div>
        <div class="inner" flex>
          <nns-todos
            [todos]="todos"
            [todosOrder]="todosOrder"
          ></nns-todos>
        </div>
      </div>
    </div>
  `
})
export class TodosPanelComponent implements OnChanges {
  @Input() todos;
  @Input() todosOrder;
  todosChecked = [];
  todosUnchecked = [];

  constructor(public _store: Store<IAppState>) {

  }

  closeTodosPanel() {
    this._store.dispatch(closeTodosPanel());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.todos) {
      this.todosChecked = this.todos.filter((x) => !!x.checked);
      this.todosUnchecked = this.todos.filter((x) => !x.checked);
    }
  }

  @HostListener('document:keydown.esc', ['$event'])
  closeFullScreen() {
    this._store.dispatch(closeTodosPanel());
  }
}
